export default __webpack_public_path__ + "static/media/left-arrow-button-wood.45d5cb09.png";